import { cashEntitlementStatusMeta } from "./cashEntitlement";

export function mapCashEntitlementRow(row) {
  if (!row) return row;
  const status = cashEntitlementStatusMeta(row);
  return {
    ...row,
    amount: Number(row.amount) || 0,
    statusLabel: status.label,
    statusClassName: status.className,
    treasuryTargets: Array.isArray(row.treasuryTargets)
      ? row.treasuryTargets
      : [],
    cashierTargets: Array.isArray(row.cashierTargets)
      ? row.cashierTargets
      : [],
  };
}
